<template>
    <div class="NoticeCom">
        <van-notice-bar
            left-icon="volume-o"
            :text="noticeMsg"
            speed="20"
        />
    </div>
</template>
<script setup>
import { ref } from "vue"
import { appConfig } from "../../config/app.config";

// MARK - Props
// ************************************************************************
const noticeMsg = ref(appConfig.APP_NOTICE_MESSAGE)


// MARK - LIFE CYCLE
// ************************************************************************

// MARK - Methods
// ************************************************************************
</script>
<style scoped lang="scss">
.NoticeCom {
    width: 100%;
    height: 100%;
}
</style>
